<template>
  <footer class="common-footer">
    <!-- 메인 정보 영역 -->
    <div class="footer-main">
      <div class="footer-inner">
        <!-- 브랜드 & 전화번호 -->
        <div class="footer-brand">
          <div class="brand-logo">
            <span class="logo-main">청주 레이원시티</span>
            <span class="logo-sub">홍보관 상담센터</span>
          </div>
          <a href="tel:1666-6818" class="footer-phone">
            <span class="phone-label">대표문의</span>
            <span class="phone-number">1666-6818</span>
          </a>
        </div>

        <!-- 정보 그리드 -->
        <div class="info-grid">
          <div class="info-item full-width">
            <span class="info-label">현장위치</span>
            <span class="info-value">청주시 흥덕구 송절동 산 76-2번지 일원</span>
          </div>
          <div class="info-item">
            <span class="info-label">홈페이지 운영</span>
            <span class="info-value">주식회사 더한걸음</span>
          </div>
          <div class="info-item">
            <span class="info-label">이메일</span>
            <span class="info-value">info@step1.kr</span>
          </div>
          <div class="info-item">
            <span class="info-label">홈페이지 관련 문의</span>
            <span class="info-value"><a href="tel:1533-9048" class="info-phone">1533-9048</a></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 하단: 면책조항 & 저작권 -->
    <div class="footer-bottom">
      <div class="footer-inner">
        <div class="disclaimers">
          <p>본 사이트는 청주 레이원시티 홍보관 상담센터 정보 제공 페이지입니다.</p>
          <p>※ 본 사이트는 분양 상담 및 방문 예약 안내를 위한 사이트이며, 사업 및 분양과 관련된 자세한 사항은 상담을 통해 안내받으실 수 있습니다.</p>
          <p>본 사이트는 청주 레이원시티 분양 상담 및 방문 예약 안내를 위한 홍보 상담 페이지입니다.</p>
          <p>시행사 및 시공사의 공식 홈페이지가 아니며 상담 안내 서비스를 제공하는 페이지입니다.</p>
          <p>분양 관련 상세 정보는 모델하우스 상담을 통해 안내받으실 수 있습니다.</p>
        </div>
        <div class="copyright">
          <span>Copyright ⓒ 2026 주식회사 더한걸음. All rights reserved.</span>
          <router-link to="/privacy" class="privacy-link">개인정보처리방침</router-link>
        </div>
      </div>
    </div>

    <!-- 워터마크 -->
    <img src="@/assets/logo/logo_symbol.png" alt="" class="watermark-logo" />
  </footer>
</template>

<script>
export default {
  name: 'CommonFooter'
}
</script>

<style scoped>
.common-footer {
  width: 100%;
  background: #0a0a0a;
  position: relative;
  overflow: hidden;
}

/* 워터마크 */
.watermark-logo {
  position: absolute;
  bottom: -50px;
  right: -80px;
  width: 400px;
  height: auto;
  opacity: 0.03;
  pointer-events: none;
  z-index: 0;
}

/* 푸터 메인 */
.footer-main {
  padding: 60px 0;
  position: relative;
  z-index: 1;
}

.footer-inner {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

.footer-main .footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
}

/* 브랜드 영역 */
.footer-brand {
  flex: 0 0 auto;
}

.brand-logo {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
}

.logo-main {
  font-family: var(--font-pretendard);
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
}

.logo-sub {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
}

.footer-phone {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-decoration: none;
  padding: 16px 24px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.footer-phone:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: var(--rayone-primary);
}

.phone-label {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 2px;
}

.phone-number {
  font-family: var(--font-paperlogy);
  font-size: 24px;
  font-weight: 700;
  color: var(--rayone-primary-light);
  letter-spacing: 1px;
}

/* 정보 그리드 */
.info-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 60px;
  max-width: 550px;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 600;
  color: var(--rayone-primary-light);
  letter-spacing: 2px;
  text-transform: uppercase;
}

.info-value {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.info-phone {
  font-family: var(--font-paperlogy);
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.info-phone:hover {
  color: var(--rayone-primary-light);
}

/* 푸터 하단 */
.footer-bottom {
  padding: 24px 0 100px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  position: relative;
  z-index: 1;
}

.footer-bottom .footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 40px;
}

.disclaimers {
  flex: 1;
}

.disclaimers p {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.3);
  line-height: 1.7;
  margin-bottom: 4px;
}

.disclaimers p:last-child {
  margin-bottom: 0;
}

.copyright {
  flex: 0 0 auto;
}

.copyright {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.copyright span {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 1px;
}

.privacy-link {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.3s ease;
}

.privacy-link:hover {
  color: var(--rayone-primary-light);
}

/* 모바일 반응형 */
@media (max-width: 768px) {
  .footer-main {
    padding: 40px 0;
  }

  .footer-inner {
    padding: 0 20px;
  }

  .footer-main .footer-inner {
    flex-direction: column;
    gap: 32px;
  }

  .footer-brand {
    width: 100%;
    text-align: center;
  }

  .brand-logo {
    align-items: center;
    margin-bottom: 20px;
  }

  .logo-main {
    font-size: 24px;
  }

  .logo-sub {
    font-size: 12px;
  }

  .footer-phone {
    display: inline-flex;
    padding: 14px 28px;
  }

  .phone-number {
    font-size: 22px;
  }

  .info-grid {
    width: 100%;
    max-width: none;
    grid-template-columns: 1fr 1fr;
    gap: 20px 24px;
  }

  .info-label {
    font-size: 10px;
  }

  .info-value {
    font-size: 13px;
  }

  .footer-bottom {
    padding: 20px 0 160px;
  }

  .footer-bottom .footer-inner {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
  }

  .disclaimers p {
    font-size: 10px;
  }

  .copyright span {
    font-size: 10px;
  }

  .watermark-logo {
    width: 200px;
    bottom: -30px;
    right: -40px;
  }
}
</style>
